import React from "react"

import {
  Modal,
  ModalOverlay,
  ModalContent,
  CloseButton,
  Box,
} from "@chakra-ui/react"

const Lightbox = ({ children, isOpen, onClose }) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        allowPinchZoom
        size="full"
      >
        <ModalOverlay
          backdropFilter="blur(15px)"
          backgroundColor="rgba(255, 255, 255, .15)"
        >
          <Box
            display="flex"
            alignItems="center"
            position="absolute"
            right="1rem"
            top="1rem"
            zIndex={"var(--chakra-zIndices-modal)"}
            bg="#ffffff00"
            cursor="pointer"
            onClick={onClose}
          >
            SCHLIESSEN <CloseButton display="inline" size="lg" mt={-1} />
          </Box>
        </ModalOverlay>
        <ModalContent
          w="94vw"
          h="100%"
          maxW="1000px"
          mt={0}
          mb={0}
          bg="transparent"
          border="none"
          boxShadow="none"
          display="grid"
          alignContent="center"
          onClick={onClose}
        >
          {children}
          {/* <ModalBody
            position="relative"
            w="100%"
            h="100%"
            bg="green"
            position="absolute"
            left={0}
            top={0}
          >
            <Box
              w="100%"
              h="100%"
              bg="green"
              position="absolute"
              left={0}
              top={0}
              zIndex={1}
            >
            </Box>
          </ModalBody> */}
        </ModalContent>
      </Modal>
    </>
  )
}

export default Lightbox
